import * as types from "../actions/actionTypes";
import { getAllAuditLogsResponse, getAuditLogByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const auditlogEntity = createEntitySagas({
  entity: "auditlog",
  endpoint: "audit-logs",
  label: "Audit log",
  scope: "company",
  injectCompanyId: true,
  computedFields: ["userName","brandName"],
  selectSlice: (state) => state.auditlog,
  listKey: "logs",
  types: {
    getAll: types.GET_ALL_AUDIT_LOGS,
    getById: types.GET_AUDIT_LOG_BY_ID,
    create: types.CREATE_AUDIT_LOG,
    update: types.UPDATE_AUDIT_LOG,
    remove: types.DELETE_AUDIT_LOG,
  },
  actions: { getAllResponse: getAllAuditLogsResponse, getByIdResponse: getAuditLogByIdResponse },
});

export const auditlogSaga = auditlogEntity.watcher;
